import styled, { css } from 'styled-components';
import { colors, remCalc } from '@prisjakt/ui-base';

export const PropertyTable = styled.table`
  line-height: ${remCalc(16)};
  color: ${props => props.theme.text.secondary};
  margin: 5px 0 10px 0;
  text-align: left;
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  border-bottom: 1px solid ${p => p.theme.lines.primary};
  &:first-child {
    border-top: 1px solid ${p => p.theme.lines.primary};
  }
  > td:first-child,
  > th:first-child {
    border-right: 1px solid ${p => p.theme.lines.primary};
  }
`;

const tableCellStyle = css`
  margin: 0;
  padding: 8px;
`;

export const TableHeader = styled.th`
  ${tableCellStyle}
  width: 15em;
  max-width: 50%;
  padding-left: 0;
  font-weight: normal;
`;

export const TableCell = styled.td`
  ${tableCellStyle}
  padding-right: 0;
  background-color: ${colors.semiWhite};
`;

export const PlaceholderProperty = styled.div`
  background: ${colors.semiWhite};
  height: ${remCalc(18)};
  width: 200px;
  border-radius: 3px;
`;
